import type {InviteParams} from "@/lib/auth"

const KEY = "agenta:pending-invite"

/** Keep the invite across sign-in, including an OIDC round trip that drops the query. */
export const writePendingInvite = (invite: InviteParams): void => {
    if (!invite.token || !invite.organization_id) return
    try {
        localStorage.setItem(KEY, JSON.stringify(invite))
    } catch {
        // Storage blocked: the invite link still works when opened again after sign-in.
    }
}

export const readPendingInvite = (): InviteParams | null => {
    try {
        const raw = localStorage.getItem(KEY)
        const invite = raw ? (JSON.parse(raw) as InviteParams) : null
        return invite?.token && invite.organization_id ? invite : null
    } catch {
        return null
    }
}

export const clearPendingInvite = (): void => {
    try {
        localStorage.removeItem(KEY)
    } catch {
        // Nothing stored to clear.
    }
}
